export default "__VITE_ASSET__d4866d96__"